import { NgIf } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router, RouterLink, RouterOutlet } from '@angular/router';
import { FuseFullscreenComponent } from '@fuse/components/fullscreen';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';
import { FuseHorizontalNavigationComponent, FuseNavigationService, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { Navigation } from 'app/core/navigation/navigation.types';
import { QuickChatComponent } from 'app/layout/common/quick-chat/quick-chat.component';
import { ShortcutsComponent } from 'app/layout/common/shortcuts/shortcuts.component';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { NetworkPanelComponent } from 'app/modules/network_panel/network_panel.component';
import { AuthService } from 'app/core/auth/auth.service';
// import { AuthService } from 'app/core/auth/auth.service';
import { SharedMethodsModule } from 'app/core/shared-services/shared-methods.module';
import { MatMenuModule } from '@angular/material/menu';
import { MatBadgeModule } from '@angular/material/badge';
import { WebStorage } from 'app/core/shared-services/web.storage';
import { FooterComponent } from 'app/modules/landing/footer/footer.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { sha256 } from 'js-sha256';
import { UserIdleService } from 'angular-user-idle';



@Component({
    selector     : 'enterprise-layout',
    templateUrl  : './enterprise.component.html',
    styleUrls    : ['./enterprise.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone   : true,
    imports      : [
        MatMenuModule, MatBadgeModule, FooterComponent, SharedMethodsModule,FuseLoadingBarComponent, NgIf, RouterLink, 
        FuseVerticalNavigationComponent, MatButtonModule, MatIconModule, FuseFullscreenComponent, ShortcutsComponent, 
        FuseHorizontalNavigationComponent, RouterOutlet, QuickChatComponent,NetworkPanelComponent
    ],
})
export class EnterpriseLayoutComponent implements OnInit, OnDestroy
{
    // @ViewChild('searchTextRef') searchInputRef: ElementRef;
    @ViewChild('inActivityDialog') inActivityDialog: any;

    
    isScreenSmall: boolean;
    navigation: Navigation;
    loggedIn: boolean;
    customerAccount:any;
    shortenedProfileDisplay:string;
    public cartValue: number;
    public countDownValue: number;
    private inactivityCount = new BehaviorSubject<number>(0);

    private _unsubscribeAll: Subject<any> = new Subject<any>();
    public searchInputRef: ElementRef;

    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _navigationService: NavigationService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        private _authService: AuthService,
        private _sharedMethods: SharedMethodsModule,
        private router: Router,
        private _webStorage: WebStorage,
        private dialog: MatDialog,
        private userIdle: UserIdleService,
    


    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    async ngOnInit()
    {

        // if (this._authService._authenticated) {
        //     console.log(this._authService._authenticated);
        //     this.hashCustomerDetails();
        // }

        // Subscribe to navigation data
        this._navigationService.navigation$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((navigation: Navigation) =>
            {
                this.navigation = navigation;
            });

        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({matchingAliases}) =>
            {
                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('md');
            });

           
        var accessToken = this._authService.accessToken;
     

        if (accessToken)
        {            
            this.loadCustomerAccount();
        }

        // Register to Cart Subject
        this._webStorage.CartInfo.subscribe({
            next: (res) => {
                if (res.PackageEntityID) {
                    this.cartValue = 1
                } else {
                    this.cartValue = 0
                }
            }
        })
    }

    private async loadCustomerAccount(): Promise<void> 
    {
        const res = await this._sharedMethods.getCustomerAccount();
        
        if (res.success && res.result) 
        {
            this.customerAccount = res.result;
            this.loggedIn = true;
            this.shortenedProfileDisplay = this.getFirstLetters(this.customerAccount.AccountName);

            //Start watching for user inactivity.
                        this.userIdle.startWatching();
                        
                        // Start watching when user idle is starting.
                        this.userIdle.onTimerStart().subscribe(count => {
                            this.inactivityCount.next(count);
                        });


                        // Subscribe to countdown ticks
                        this.inactivityCount.subscribe(value => {
                            this.countDownValue = 60 - value;
                            if (value == 1) {
                                this.dialog.open(this.inActivityDialog, {
                                    width: '500px',
                                    backdropClass: 'blurModalBackground'
                                });
                            }
                        });
                        
                        // Start watch when time is up.
                        this.userIdle.onTimeout().subscribe(() => {
                            
                            this.dialog.closeAll();
                            this.userIdle.stopTimer();
                            this.userIdle.stopWatching();

                            this._authService.signOut();
                            this.router.navigate(['/home']);
                        });
        } 
        else 
        {
            this.loggedIn = false;
        }
    }

    public resetInactivityTimer() {
        this.dialog.closeAll();
        this.userIdle.stopTimer();
    }
    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void
    {
        // Get the navigation
        const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);

        if ( navigation )
        {
            // Toggle the opened status
            navigation.toggle();
        }
    }

    getFirstLetters(profileName)
    {
        return profileName
          .split(' ')
          .map(word => word[0])
          .join('');
    }

    menuItemClick(...navItems) 
    {
        if (navItems.filter(Boolean).length > 2) {
            const queryParam = navItems.filter(Boolean);
            const navObj = queryParam.splice(0,2)
            this.router.navigate(navObj, {queryParams: { segment: queryParam}});
        } else {
            const navObj = navItems.filter(Boolean);
            this.router.navigate(navObj);
        }
    }

    // signOutPrompt(templateRef: any) {
    //     this.dialog.open(templateRef, {
    //         width: '800px',
    //         backdropClass: 'blurModalBackground'
    //       });
    // }

    // closeDialog(): void {
    //     this.dialog.closeAll();
    // }

    signOut(): void
    {
        localStorage.removeItem('emailHash');
        localStorage.removeItem('phoneHash');

        this._router.navigate(['/sign-out']);
        // this.dialog.closeAll();
    }

    signIn(): void
    {
        localStorage.removeItem("accessToken");
        this._router.navigate(['/sign-in']);
    }

    signUpRequired(){
        // ## BUG FIX FOR CART AND LOGIN PAGE ##
        sessionStorage.setItem('signUpRequired', null);
    }


    showCart(){
       const token = this._authService.accessToken;
        if(token){
            return true
        }else{
            return false;
        }
    }

    focusOnSearch(): void 
    {
        if (this.searchInputRef) {
            this.searchInputRef?.nativeElement.focus();
        }
    }

    // private async hashCustomerDetails() {
    //     console.log(this._authService);
    //         if ((!localStorage.getItem('emailHash') || !localStorage.getItem('phoneHash')) && this._authService._authenticated) {
    //             await this._sharedMethods.getCustomerAccount().then((res) => {
    //                 if (res.success) {
    //                     const user = res.result;
        
    //                     console.log(user);
    //                     localStorage.setItem('emailHash', sha256(user?.PrimaryContactEmail));
    //                     localStorage.setItem('phoneHash', sha256(user?.MobileUsername));
    //                 }
    //             });
    //         } else {
    //             console.log('nah');
    //             return
    //         }
        
    // }
}
